import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/lib/i18n";

export default function Imprint() {
  const { t } = useLang();
  return (
    <div className="App relative min-h-screen" data-testid="imprint-page">
      <Header />
      <main className="pt-40 pb-24 max-w-[820px] mx-auto px-6 lg:px-10">
        <span className="pill"><i className="fa-solid fa-file-shield" /> {t("imprint.pill")}</span>
        <h1 className="mt-5 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          {t("imprint.title")}
        </h1>
        <p className="mt-4 text-[hsl(var(--ink-soft))]">{t("imprint.sub")}</p>

        <div className="mt-12 soft-card p-8 lg:p-10 space-y-6">
          <section>
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
              {t("imprint.responsible")}
            </div>
            <div className="mt-3 font-display text-xl font-semibold">{t("imprint.company")}</div>
            <address className="not-italic mt-2 text-[hsl(var(--ink-soft))] leading-relaxed">
              {t("imprint.address").map((line, i) => (
                <span key={i}>
                  {line}
                  {i < t("imprint.address").length - 1 && <br />}
                </span>
              ))}
            </address>
          </section>

          <div className="divider" />

          <section className="grid sm:grid-cols-2 gap-6">
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
                {t("imprint.phone")}
              </div>
              <a href="tel:+41325100620" className="mt-2 inline-block font-display text-lg font-medium hover:text-[hsl(var(--accent))] transition-colors">
                +41 32 510 06 20
              </a>
            </div>
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
                {t("imprint.email")}
              </div>
              <a href="mailto:hello@webprintmedia.swiss" className="mt-2 inline-block font-display text-lg font-medium hover:text-[hsl(var(--accent))] transition-colors">
                hello@webprintmedia.swiss
              </a>
            </div>
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
                {t("imprint.whatsapp")}
              </div>
              <a href="https://wa.me/41793150600" target="_blank" rel="noreferrer" className="mt-2 inline-block font-display text-lg font-medium hover:text-[hsl(var(--accent))] transition-colors">
                +41 79 315 06 00
              </a>
            </div>
            <div>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
                {t("imprint.hq")}
              </div>
              <div className="mt-2 font-display text-lg font-medium">{t("imprint.hqValue")}</div>
            </div>
          </section>

          <div className="divider" />

          <section className="space-y-4 text-[14px] leading-relaxed text-[hsl(var(--ink-soft))]">
            <p>{t("imprint.copyParagraph")}</p>
            <p>{t("imprint.brandsParagraph")}</p>
            <p>{t("imprint.linksParagraph")}</p>
          </section>
        </div>

        <a href="/" data-testid="imprint-back" className="mt-10 inline-flex items-center gap-2 text-sm font-medium link-underline">
          <i className="fa-solid fa-arrow-left" />
          {t("imprint.back")}
        </a>
      </main>
      <Footer />
    </div>
  );
}
